import { SessionInterface } from "../../../domain/interface/session_interface";
import VisitCardIcon from '../../../../../assets/images/visit_card_icon.svg?react';
import { useTranslation } from '../../../../../i18n/useTranslation';
import { getCurrentLocale } from '../../../../../i18n/config';

interface CalendarElementProps extends SessionInterface {
    color: string;
}

const CalendarElement: React.FC<CalendarElementProps> = ({ color, vibesTheme, start, end, meetingDuration, title, visitAllowed }) => {
    const { t } = useTranslation();
    const formatTime = (date: Date): string => {
        const locale = getCurrentLocale();
        const time = date.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' });
        return locale === 'fr-FR' ? time.replace(':', 'h') : time;
    };

    const formatDate = (date: Date): { day: string; month: string } => {
        const locale = getCurrentLocale();
        const day = String(date.getDate());
        const shortMonth = date.toLocaleDateString(locale, { month: 'short' });
        // Certaines langues (bulgare) renvoient le mois en chiffres : on abrège le nom complet.
        const month = (/^\d+$/.test(shortMonth) ? date.toLocaleDateString(locale, { month: 'long' }).slice(0, 3) : shortMonth).toLocaleUpperCase(locale);
        return { day, month };
    };

    const { day, month } = formatDate(start);

    return (

        <div className="relative flex flex-col min-w-44.25 max-w-44.25 px-3 pt-3 pb-4 rounded-[20px] gap-3.75 text-white star-background-image" style={{ backgroundColor: color }}>
            <div className="flex items-center gap-2.5">
                <div className="flex flex-col bg-white h-15 w-16 rounded-lg justify-center items-center">
                    <p className="text-3xl font-bold leading-[0.67] pt-px" style={{ color: color }}>{day}</p>
                    <p className="text-black leading-tight">{month}</p>
                </div>
                <div className='flex flex-col'>
                    <p className='font-bold text-sm leading-5'>
                        {t('home.calendar.vibes')}<br/>
                        <span className='font-light'>{title}</span>
                    </p>
                </div>
            </div>
            <div className="flex items-end justify-between w-full">
                <div className="flex flex-col gap-0.75 w-full">
                    <div className="flex flex-col gap-px">
                        <p className="text-xs font-light">{t('home.session.theme')}</p>
                        <p className="text-md font-medium">{vibesTheme}</p>
                    </div>
                    <div className="flex flex-col gap-px">
                        <p className="text-xs font-light">{t('home.session.schedule')}</p>
                        <p className="text-md font-medium">{`${formatTime(start)} - ${formatTime(end)}`}</p>
                    </div>
                    <div className="flex w-full items-end justify-between gap-3">
                        <div className="flex flex-col gap-px">
                            <p className="text-xs font-light">{t('home.session.duration')}</p>
                            <p className="text-md font-medium">{t('common.unit.minutes', { count: meetingDuration })}</p>
                        </div>
                        {visitAllowed && <VisitCardIcon className="h-5 w-auto"/>}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CalendarElement;